module.exports = __webpack_public_path__ + "static/img/AZ.5f4e467b.png";